export default "__VITE_ASSET__CnYnK_4X__"